module.exports = __webpack_public_path__ + "assets/img/247001.d4c0073f.png";